module.exports = __webpack_public_path__ + "fonts/5156391.ttf";